<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col cols="12" xl="12">
                <transition name="slide">
                    <b-card>
                        <template slot="header">
                            <div class="card-header-actions">
                            <b-link class="card-header-action btn-setting" to="create" :append="true">
                                <i class="icon-plus"></i>
                            </b-link>
                            </div>
                        </template>
                        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" @row-clicked="edit">
                        </b-table>
                    </b-card>
                </transition>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: "Users",
    props: {
        caption: {
        type: String,
        default: 'Users'
        },
        hover: {
        type: Boolean,
        default: true
        },
        striped: {
        type: Boolean,
        default: true
        },
        bordered: {
        type: Boolean,
        default: false
        },
        small: {
        type: Boolean,
        default: false
        },
        fixed: {
        type: Boolean,
        default: false
        }
    },
    computed: {
        items() {
            return this.$store.getters.getRoles
        }
    },
    methods: {
        edit(item) {
            this.$router.push({path:"/admin/users/roles/edit/" + item.uuid})
        }
    },
    data: function() {
        return {
            fields: ["name"],
            currentPage: 1,
            perPage: 9999,
            totalRows: 0
        }
    },
    mounted() {
        this.$store.dispatch("fetchRoles", true)
    }
}
</script>
